module.exports = __webpack_public_path__ + "static/media/img-pago.66f253a9.gif";